import React from 'react';
import { graphql } from 'gatsby';
import SiteLayout from '../components/SiteLayout';
import Pricing from '../components/Pricing';
import SEO from '../components/SEO';

const PricingPage = ({
  location,
  data: {
    wpgraphql: { pageBy: page },
  },
}) => (
  <SiteLayout location={location}>
    <SEO page={page} path={location.pathname} />
    <Pricing isFullPricing />
  </SiteLayout>
);

export default PricingPage;

export const query = graphql`
  query {
    wpgraphql {
      pageBy(uri: "/pricing/") {
        ...SEOPageFragment
      }
    }
  }
`;
